module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_jarfalla-7402494c1fbd8ce7b85a4245e4139bb0.png";